(function () {
	const multicolumnSlider = () => {
		const multicolumnSliders = Array.from(
			document.querySelectorAll(".multicolumn-slider")
		);
		if (multicolumnSliders.length === 0) return;
		multicolumnSliders.forEach((slider) => {
			const sectionId = slider.dataset.id;
			const perRow = slider.dataset.perRow;
			const mobileR = slider.dataset.mobile;
			const speed = slider.dataset.speed * 1000;
			const autoplay = toBoolean(slider.dataset.autoplay);
			const stopAutoplaySlider = toBoolean(slider.dataset.stopAutoplay);
			let autoplayParm = {};

			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
					},
				};
			}

			const multicolumnSwiper = new Swiper(`#${sectionId} .swiper`, {
				loop: true,
				longSwipesRatio: 0.1,
				slidesPerView: mobileR,
				allowTouchMove: true,
				speed: speed,
				breakpoints: {
					//576: {
					//  slidesPerView: 2,
					//},
					1200: {
						slidesPerView: +perRow + 0.4,
					},
				},
				//...autoplayParm,
			});
			if (autoplay && stopAutoplaySlider) {
				let duration;
				let distanceRatio;
				let startTimer;
				const swiperWrapperEl = document.querySelector(
					`#${sectionId} .swiper-wrapper`
				);

				const stopAutoplay = () => {
					if (startTimer) clearTimeout(startTimer);

					multicolumnSwiper.setTranslate(multicolumnSwiper.getTranslate());

					const currentSlideWidth =
						multicolumnSwiper.slides[multicolumnSwiper.activeIndex].offsetWidth;
					distanceRatio = Math.abs(
						(currentSlideWidth * multicolumnSwiper.activeIndex +
							multicolumnSwiper.getTranslate()) /
							currentSlideWidth
					);

					duration = multicolumnSwiper.params.speed * distanceRatio;
					multicolumnSwiper.autoplay.stop();
				};

				const startAutoplay = (delay = duration) => {
					startTimer = setTimeout(() => {
						multicolumnSwiper.autoplay.start();
					}, delay);
				};

				swiperWrapperEl.addEventListener("mouseenter", function () {
					stopAutoplay();
				});

				swiperWrapperEl.addEventListener("mouseleave", function () {
					const distance =
						multicolumnSwiper.width * multicolumnSwiper.activeIndex +
						multicolumnSwiper.getTranslate();

					duration = distance !== 0 ? duration : 0;
					multicolumnSwiper.slideTo(multicolumnSwiper.activeIndex, duration);
					startAutoplay();
				});
			}
		});
	};
	function toBoolean(string) {
		return string === "true" ? true : false;
	}
	document.addEventListener("DOMContentLoaded", function () {
		multicolumnSlider();
		document.addEventListener("shopify:section:load", function () {
			multicolumnSlider();
		});
	});
})();
